import APIService from "./APIService";

const API_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT + "currencies";

export default {
  getCurrencies() {
    return APIService.get(API_END_POINT);
  }
}